import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { variabilitiesListAPI, variabilitiesUpdateAPI } from '../apiService';
import { checkApiStatus } from '../../../../utils';
import { globalGetService, globalPutService } from '../../../../utils/globalApiServices';
import { useParams } from 'react-router';
import { enqueueSnackbar } from 'notistack';
import { STableLoader } from '../../../../shared_elements';
import { ButtonLoader } from '../../../../shared_elements/components';
import moment from 'moment/moment';
import {  Edit as EditIcon} from '@mui/icons-material';
import { trackActivity } from '../../../../utils/mixpanel';
import { numberWithCommas } from '../../../../utils';
import { regexConstants } from '../../../../constants/regEx';

const VariabilityScheduleHeader = () => {
  return (
    <TableHead>
      <TableRow>
        <TableCell>Start Date</TableCell>
        <TableCell>End Date</TableCell>
        <TableCell>Stipulated Requirement (USD)</TableCell>
        <TableCell>Variability (%)</TableCell>
      </TableRow>
    </TableHead>
  );
};

const VariabilityScheduleList = ({ item,error,setError,variabilityCRU,onRestErrorKey, index, onChange }) => {

  return (
    <TableRow>
      <TableCell>{item?.start_date ? moment(item.start_date).format("DD MMM, YYYY") : '--'}</TableCell>
      <TableCell>{item?.end_date ? moment(item.end_date).format("DD MMM, YYYY") : '--'}</TableCell>
      <TableCell>
       {index === 0 ? <TextField  onFocus={()=>onRestErrorKey(`amount-${item.id}`)} disabled={variabilityCRU?.mode==="view"} error={!!error[`amount-${item.id}`]} helperText={error[`amount-${item.id}`]} sx={{"& .MuiOutlinedInput-input":{height:"7px",width:"150px"}}} value={item?.amount??''} size="small" variant="outlined" onChange={e=>{const val=e.target.value; if(val===""||(val.length<=15&&regexConstants.decimalnodotstart.test(val))) onChange(item.id,"amount",val)}}/>:<Box sx={{marginLeft:"15px"}}>{item?.amount !== null && item?.amount !== undefined && item?.amount !== '' ? numberWithCommas(Number(item.amount).toFixed(2)) : ' '}</Box>}
      </TableCell>
      <TableCell >
      <TextField sx={{width:120,"& .MuiOutlinedInput-input":{height:"7px"}}} disabled={index===0||variabilityCRU?.mode==="view"} error={!!error[`variability-${item.id}`]} helperText={error[`variability-${item.id}`]} slotProps={{formHelperText:{sx:{whiteSpace:"nowrap",padding:0,marginLeft:0,width:"fit-content",overflow:"hidden",textOverflow:"ellipsis"}}}} value={index===0?"0":item?.variability} size="small" variant="outlined" onChange={(e)=>{let v=e.target.value.replace(/[^0-9.-]/g,"");if(v&&Number(v)>100)v="100";if(v&&!v.includes("%"))v+="%";onChange(item.id,"variability",v.replace("%",""));if(v!==""&&!isNaN(Number(v.replace("%",""))))setError(p=>{let n={...p};delete n[`variability-${item.id}`];return n});}}/>
    </TableCell>
    </TableRow>
  );
};

const VariabilityCRU = ({onToggleModal,modeType,onEditVariability,variabilityCRU}) => {
  const { leaseSlug } = useParams();
  const params = { leaseSlug };
  const [isLoading, setLoading] = useState(false);
  const [skeletonLoader, setSkeletonLoader] = useState(false);
  const [error, setError] = useState({});
  const [VariabilityInfo, setVariabilityInfo] = useState([]);
  
  useEffect(()=>{
     getVariabilitList("skeletonLoader",{})
  },[])

  const getVariabilitList = (loaderType, query = {}) => {
      loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
      globalGetService(variabilitiesListAPI( params?.leaseSlug,variabilityCRU?.data?.slug)).then(response => {
        if (checkApiStatus(response)) {
          loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
          setVariabilityInfo(response.data.data?.list);
        } else {
          loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
        }
      })
  };

  const onRestErrorKey = (key) => {
    setError((prev) => ({ ...prev, [key]: '' }));
  };

  const onFieldChange = (id, field, value) => {
   setVariabilityInfo(prev => {
    let updated = prev.map(row => row.id === id ? { ...row, [field]: value } : row);
    const rowIndex = updated.findIndex(row => row.id === id);
    if (field === "variability") {
      const base = parseFloat(updated[rowIndex - 1]?.amount) || 0;
      const rawPercent = updated[rowIndex].variability;
      if (rawPercent !== "" && rawPercent !== null && !isNaN(rawPercent)) {
        const percent = parseFloat(rawPercent);
        const calc = variabilityCRU?.data?.variability?.label === "Decrease"
          ? base - (base * percent / 100)
          : base + (base * percent / 100);
        updated[rowIndex] = { ...updated[rowIndex], amount: calc.toFixed(2) };
        if (updated[rowIndex + 1]) {
          updated[rowIndex + 1] = { ...updated[rowIndex + 1], amount: calc.toFixed(2) };
        }
      }
    }
    if (field === "amount") {
      let base = parseFloat(updated[rowIndex]?.amount) || 0;
      for (let i = rowIndex + 1; i < updated.length; i++) {
        const rawPercent = updated[i].variability;
        if (rawPercent !== "" && rawPercent !== null && !isNaN(rawPercent)) {
          const percent = parseFloat(rawPercent);
          const calc = variabilityCRU?.data?.variability?.label === "Decrease"
            ? base - (base * percent / 100)
            : base + (base * percent / 100);
          updated[i] = { ...updated[i], amount: calc.toFixed(2) };
          base = calc;
        } else {
          updated[i] = { ...updated[i], amount: base.toFixed(2) };
          break;
        }
      }
    }
    return [...updated];
   });
  };

const onSubmitVariability = () => {
  let validationErrors = {};
  const isValidAmount = (value) => { if (value === null || value === undefined) return false; if (typeof value === "string" && value.trim() === "") return false; const num = Number(value); return !isNaN(num); };
  VariabilityInfo.forEach((row, index) => {
    if (!isValidAmount(row.amount)) {
      validationErrors[`amount-${row.id}`] = "Please enter Stipulated Amount";
    }
    if (index !== 0 && (!row.variability && row.variability !== 0)) {
      validationErrors[`variability-${row.id}`] = "Please enter Variability";
    }
  });
  if (Object.keys(validationErrors).length === 0) {
    setLoading(true);
    globalPutService(
      variabilitiesUpdateAPI(params?.leaseSlug, variabilityCRU?.data?.slug),
      VariabilityInfo
    ).then(async (response) => {
      if (checkApiStatus(response)) {
        enqueueSnackbar(response?.data?.message, {
          variant: "success",
          anchorOrigin: { horizontal: "right", vertical: "top" },
        });
        onToggleModal();
        trackActivity('Item Edited', { page_title: `Edit Variability Schedule`, success_msg: response?.data?.message, item_id: variabilityCRU?.data?.id, payload: VariabilityInfo, response: response?.data })
      } else {
        enqueueSnackbar(response.data.message, {
          variant: "error",
          anchorOrigin: { horizontal: "right", vertical: "top" },
        });
        trackActivity('Item Edited', { page_title: `Edit Variability Schedule`, error_msg: response?.data?.message, item_id: variabilityCRU?.data?.id, payload: VariabilityInfo, response: response?.data })
      }
      setLoading(false);
    });
  } else {
    setError(validationErrors);
    trackActivity(`Item Edited`, { page_title: `Variability Schedule`, error_msg: validationErrors, })
  }
};
  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: 'Variability Schedule', page_type: page_type, })
  }

  return (
    <>
  <Dialog
  aria-labelledby="customized-dialog-title"
  className="add-lease-dialog"
  maxWidth="md"
  open={true}
  slotProps={{paper: {sx: { width: "630px" }}}}
  sx={{"& .MuiDialog-container": {display: "flex",alignItems: "center",justifyContent: "center",},}}
  >
    <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
      <Typography className="dialog-header-title"> Variability Schedule </Typography>
    </DialogTitle>
    <DialogContent dividers>
      <Grid container >
        <Grid size={{ md: 12, xs: 12 }}>
         <Typography>{`${variabilityCRU?.data?.insurance_type?.name} Variability Schedule`}</Typography>
        </Grid>
      </Grid>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" ,mb:"2px" }}>
            <Typography fontSize='15px'>  Variability : <Box component="span" className='insurance-variability-type'>{variabilityCRU?.data?.variability?.label || "--"}</Box></Typography>
        {VariabilityInfo?.length > 0 && (
        <Tooltip title="Edit Variability Schedule">
                {variabilityCRU?.mode !== "Add" && <EditIcon sx={{ cursor: "pointer" }} onClick={() => { onEditVariability(); handleItemClicked('Edit VariabilityIcon') }} fontSize="small" color="primary"/>}
      </Tooltip>
       )}
    </Box>
     { variabilityCRU?.data?.variability=== null ?   <Typography ><Box component="span" sx={{background:"#e9e95d" ,fontSize:"13px"}} >Note : {"Please Add Variability in the Particular Insurance to add Stipulation"}</Box></Typography> :""}
    <Grid container spacing={2}>
      
    <Grid size={{ md: 12, xs: 12 }}>
    {
      skeletonLoader ? <STableLoader count={4} rowCount={2} />:
      <>
      <Paper sx={{ maxHeight: `${window.innerHeight - 300}px`, overflowY: 'auto' }}>
       <Table className='mui-table-format' stickyHeader>
       <VariabilityScheduleHeader />
       <TableBody>
         {VariabilityInfo?.length > 0 ? (
           VariabilityInfo.map((itm, index) => (
          <VariabilityScheduleList
           error={error}
           setError={setError}
           onRestErrorKey={onRestErrorKey}
           variabilityCRU={variabilityCRU}
           key={index}
           item={itm}
           index={index}
           onChange={onFieldChange}
         />
        ))
       ) : (
       <TableRow>
       <TableCell colSpan={6} align="center">
       No record found
       </TableCell>
     </TableRow>
     )}
      </TableBody>
     </Table>
     </Paper>
      </>
    }
    </Grid>
     </Grid>
    </DialogContent>
     <DialogActions sx={{marginRight:"15px"}}>
          <Button className='cancel-btn' disabled={isLoading} color='primary' disableRipple variant='outlined' size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>{variabilityCRU?.mode === "view" || !VariabilityInfo?.length > 0 ? "Close" : "Cancel"}</Button>
          {variabilityCRU?.mode === "view" || !VariabilityInfo?.length > 0 ? null : <Button color='primary' disableRipple variant='contained' size='small' className='btn-primary' onClick={() => { handleItemClicked('Save Button'); onSubmitVariability(); }}>{isLoading ? <CircularProgress color='inherit' size={25} /> : "SAVE"}</Button>}
    </DialogActions>
    </Dialog>
    </>
  )
}

export default VariabilityCRU